module.exports = __webpack_public_path__ + "img/trans~~.0895c7d1.png";